import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const StatusContent = ({data, boName}) => {
    useEffect(() => {

        const values = [];
        const labels = [];

        data.statusBo.forEach((el) => {
            labels.push(el.status);
            values.push(el.amount);
        });

        GraphicUtils.barChart("statusBoChart", values, labels, false);
        ReportUtils.createExportableTable(labels, values, `Status dos ${boName}`)
    }, []);

    return (
        <>
            <div className="chart-report">
                <span className="chart-title">Status dos {data.boName}</span>
                <div id="statusBoChart"></div>
            </div>

            <div className="chart-divisor print-hide"></div>
        </>
    )
};

export default StatusContent;